import type { AssetInfo } from '@/interfaces/components/IImageComponent'

export const getImagePath = async (assetInfo: AssetInfo) => {
  try {
    let logo

    if (assetInfo.type === 'flag') {
      logo = await import(`../../assets/flags/${assetInfo.name}.${assetInfo.extension}`)
    } else if (assetInfo.type === 'logo') {
      logo = await import(`../../assets/logos/${assetInfo.name}.${assetInfo.extension}`)
    } else if (assetInfo.type === 'images') {
      logo = await import(`../../assets/images/${assetInfo.name}.${assetInfo.extension}`)
    }

    return logo.default
  } catch (error) {
    console.error('Error loading logo:', error)
    return ''
  }
}
